module.exports = __webpack_public_path__ + "img/logo.e0929a24.png";